import i18n from "plugins/i18n";
import moment from "plugins/moment";
import axios from "plugins/axios";
import ajax from "plugins/ajax";
import Vue from "vue";

const store = {
    namespaced: true,
    state: {
        language: "en_US",
        supported: [],
        pending: {
            language: false,
            supported: false
        }
    },
    actions: {
        /**
         * Set the language of user, and save it into database.
         *
         * @param {Store} store The Vuex store.
         * @param {String} language The language to set.
         * @return {Object} Ajax response object.
         */
        language: function(store, language) {
            return ajax(store, "put", "/users/language", language, "LANGUAGE", false, {
                type: "success",
                message: i18n.t("store.message.language-success"),
                onlyCurrentRoute: true
            }, {
                type: "error",
                autoTranslate: true,
                onlyCurrentRoute: true
            });
        },
        supportedLanguage: function(store) {
            return ajax(store, "get", "/languages", null, "SUPPORTED_LANGUAGE", false, null, {
                type: "error",
                autoTranslate: true,
                onlyCurrentRoute: true
            });
        }
    },
    mutations: {
        // Language
        API_LANGUAGE_PENDING: function() {},
        API_LANGUAGE_FAILURE: function() {},
        API_LANGUAGE_SUCCESS: function() {},

        // Supported Language
        API_SUPPORTED_LANGUAGE_PENDING: function() {},
        API_SUPPORTED_LANGUAGE_FAILURE: function() {},
        API_SUPPORTED_LANGUAGE_SUCCESS: function(state, data) {
            var i = data.length;
            while(i--) {
                if (data[i] === "simple") {
                    data.splice(i, 1);
                }
            }
            Vue.set(state, "supported", data);
        },

        /**
         * Set pending state.
         *
         * @param {Object} state The store's state.
         * @param {String} payload The name and value to set.
         */
        setPending: function(state, payload) {
            state.pending[payload.name] = payload.value;
        },

        /**
         * Set application current language.
         *
         * @param {Object} state The store's state.
         * @param {String} language The language to set (see plugins/i18n.js file).
         */
        setLanguage: function(state, language) {
            // Nothing to do if the language is already the good one.
            if (state.language === language) {
                return;
            }
            state.language = language;
            i18n.locale = language;
            // Setting language to axios
            const accepted = "" + i18n.locale + "; q=0.9, " + i18n.fallbackLocale;
            axios.defaults.headers.common["Accept-Language"] = accepted;
            moment.locale(language);
        }
    }
};

export default store;